import { FC } from 'react';

import { twMerge } from 'tailwind-merge';

import { ArrowIcon } from '../../../assets';
import { Button } from '../../button';
import { TModalLeftButton } from './types';

export const ModalLeftButton: FC<TModalLeftButton> = ({
  isIcon,
  onBack,
  onClick,
  Component,
  className,
}) => {
  if (!isIcon && Component) return Component;

  return (
    <Button
      variant="base-300"
      size="icon"
      className={twMerge(
        'absolute left-1 top-1 !z-50 h-[56px] w-[56px] rounded-full',
        className,
      )}
      onClick={onClick ?? onBack}
    >
      {(isIcon && Component) || <ArrowIcon className="!size-6" />}
    </Button>
  );
};
